import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { GfTranslateService } from "../../../core/services/core.translate.service";

@Injectable()
export class TrackerItemValidationService {
    private friendlyMap: any = {
        'in': 'one of the allowed values',
        'int': 'a whole number',
        'date': 'a valid date',
        'required': 'non-empty',
        'slug': 'lowercase letters, underscores or dashes',
        'id': 'a whole number > 0',
        'min': 'greater than {{0}}',
        'max': 'less than {{0}}',
        'length': 'between {{0}} and {{1}} characters in length',
        'transition-field-required': 'provided for this transition'
    };

    constructor(private translateService: GfTranslateService) {
    }

    /**
     * 
     * @param {array} row 
     */
    getMessageForType = (row) => {
        var type = _.get(row, 'type', '');

        // TODO Translation
        var msg = this.translateService.translate(
            _.get(this.friendlyMap, type, 'an accepted value')
        );

        var args = _.get(row, 'args', []);

        for(var i = 0; i < args.length; i++) {
            var find = "{{" + i + "}}";
            msg = msg.replace(find, args[i]);
        }

        return msg;
    }

    getFieldNameMap = (tracker) => {
        return _.mapValues(
            _.get(tracker, 'fields', {}),
            (field, alias) => { return _.get(field, 'fieldName', alias); }
        );
    }

    // {"waitingFor":[{"type":"in","args":[[100,1,2]]}, {},...]}
    buildMessageForField = (fieldName, rows) => {
        var messages = _.map(rows, this.getMessageForType);

        // Formula: <fieldname> must <err1>, ..., and <errn>
        if (messages.length > 0) {
            var ret =  fieldName + ' must be ';

            if (messages.length == 1) {
                ret += messages[0];
            } else {
                ret += messages.slice(0, -1).join(', ') + ' and ' + messages.pop();
            }
            return ret;
        }
        return false;
    }

    /* Expected validation failure format:
        { fieldName: [{
            type: "type" (in, required, maxlength, etc),
            args: []
        }], otherField: [], ...}
    */
    getValidationMessages = (tracker, response) => {
        var fieldMap = this.getFieldNameMap(tracker);

        response = response || {};

        var ret = _.map(
	    // Ignore keys that are not validation field names
            _.omit(_.keys(response), ['overwrite', '$$hashKey']),
            (key) => {
                var fieldName = _.get(fieldMap, key, '(unknown field)');
                var rows = _.get(response, key, []);
                return this.buildMessageForField(fieldName, rows);
            }
        );

        return ret.length ? ret : false;
    }
}